module.exports = __webpack_public_path__ + "static/media/coming-soon.2617fe4b.png";